import React from 'react';
import {
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  CardTitle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from 'reactstrap';
import CheckBox from '@componentes/checkbox/checkbox.component';
import '@common/vincular/vincular.styles.css';
import * as acessos from '../../../acessos.const.util';
import IntlMessage from '../../../../src/helpers/intlMessage';

const VincularPage = (props) => (
  <div className='vincular-exame-container'>
    <Modal isOpen={props.showModal} toggle={props.toggleModal}>
      <ModalHeader toggle={props.toggleModal}><IntlMessage id = "dashboards.examDetail.justification"/></ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <FormGroup className='justificativa'>
              <Label><IntlMessage id = "dashboards.examDetails.justification"/></Label>
              <Input
                type='textarea'
                name='justificativa'
                onChange={props.updateState}
                value={props.justificativa}
              />
            </FormGroup>
          </Col>
        </Row>
        {(props.frascosGravados === undefined ||
          props.frascosGravados.length === 0) &&
          parseInt(props.laudoAnterior, 10) === 0 && (
            <Row>
              <Col>
                <FormGroup style={{ marginTop: '3px' }}>
                  <CheckBox
                    label={<IntlMessage id = "dashboards.examDetail.newExam"/>}
                    onChange={(el) =>
                      props.updateMesmoMaterial(
                        'mesmoMaterial',
                        el.currentTarget.checked
                      )
                    }
                    checked={props.mesmoMaterial}
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
      </ModalBody>
      <ModalFooter>
        <Button onClick={props.toggleModal} color='secondary'>
          <IntlMessage id = "dashboards.examDetail.comeBack"/>
        </Button>
        {parseInt(props.laudoAnterior, 10) === 0 && (
          <Button
            onClick={props.vincularExame}
            disabled={!props.justificativa}
            color='primary'
          >
            <IntlMessage id = "dashboards.examDetail.link"/>
          </Button>
        )}
        {parseInt(props.laudoAnterior, 10) !== 0 && (
          <Button
            onClick={props.desvincularExame}
            disabled={!props.justificativa}
            color='primary'
          >
            <IntlMessage id = "dashboards.examDetail.noLink"/>
          </Button>
        )}
      </ModalFooter>
    </Modal>
    <p className='title'><IntlMessage id = "dashboards.examDetail.selectExam"/> {props.vincularTexto}:</p>
    <Row>
      {props.exames.length > 0 && (
        <div
          style={{
            height: `${props.altura - 38}px`,
            width: '100%',
            overflowY: 'scroll',
            overflowX: 'hidden',
          }}
        >
          <Col>
            {props.exames.map((item) => {
              let macroscopia = item.etapas.find((etp) => {
                return etp.etapa === 'MACRO';
              });

              let macroFinalizada = macroscopia.status === 'realizado';

              return (
                <Row key={item.id}>
                  <Col>
                    <Card
                      className={
                        item.laudo === parseInt(props.laudoAnterior, 10)
                          ? 'vinculado'
                          : undefined
                      }
                    >
                      <Row>
                        <Col sm={5} className='align-self-center'>
                          <CardBody>
                            <CardTitle>
                              {`${item.numeroExame} - ${item.exame}`}
                            </CardTitle>
                          </CardBody>
                        </Col>
                        <Col sm={4} className='align-self-center'>
                          {props.retornarUltimaEtapa(item.etapas)}
                        </Col>
                        {props.acessoPermitido(
                          props.usuario,
                          acessos.VincularExame
                        ) &&
                          props.acessoPermitido(
                            props.usuario,
                            acessos.Adicionar
                          ) &&
                          (!props.laudoAnterior ||
                            parseInt(props.laudoAnterior, 10) === 0) &&
                          item.laudo !== parseInt(props.laudoAnterior, 10) &&
                          !props.recebimentoFinalizado &&
                          !props.exameFinalizado && (
                            <Col
                              sm='3'
                              className='align-self-center btn-vincular'
                            >
                              <FormGroup>
                                <Button
                                  color='info'
                                  disabled={!macroFinalizada}
                                  className='vincularExame-button'
                                  name='vincular'
                                  onClick={() => props.toggleModal(item)}
                                >
                                  <span><IntlMessage id = "dashboards.examDetail.linkReport"/> {item.laudo}</span>
                                </Button>
                              </FormGroup>
                            </Col>
                          )}
                        {props.acessoPermitido(
                          props.usuario,
                          acessos.VincularExame
                        ) &&
                          props.acessoPermitido(
                            props.usuario,
                            acessos.Adicionar
                          ) &&
                          item.laudo === parseInt(props.laudoAnterior, 10) && (
                            <Col
                              sm='3'
                              className='align-self-center btn-vincular'
                            >
                              <FormGroup>
                                <Button
                                  color='danger'
                                  className='vincularExame-button'
                                  name='desvincular'
                                  onClick={() => props.toggleModal(item)}
                                >
                                  <span><IntlMessage id = "dashboards.examDetail.noLinkReport"/> {item.laudo}</span>
                                </Button>
                              </FormGroup>
                            </Col>
                          )}
                      </Row>
                    </Card>
                  </Col>
                </Row>
              );
            })}
          </Col>
        </div>
      )}
    </Row>
  </div>
);

export default VincularPage;



// WEBPACK FOOTER //
// ./src/app/common/vincular/vincular.page.js